import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DragAndDropFiles from "@mirage/components/dragAndDrop/DragAndDropFiles";
import { MirageTheme } from "@mirage/theme/MuiMirage.module";
import { Chip, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import { FileContent } from "@shared/mirage/core/contracts/UploadedFile";
import React, { memo, useCallback } from "react";
import { atom, useRecoilState } from "recoil";

export const commentFiles = atom({
    key: "comment-attachments",
    default: [] as File[],
});

interface NewCommentAttachmentsProps {
    errorMsg?: string;
}

const NewCommentAttachments = memo((props: NewCommentAttachmentsProps) => {
    const [files, setFiles] = useRecoilState<File[]>(commentFiles);
    const { errorMsg } = props;
    const removeAttachment = (index: number) => {
        setFiles((prev) => {
            const copy = [...prev];
            copy.splice(index, 1);
            return [...copy];
        });
    };

    const handleFileDrop = useCallback(
        (files: FileContent[], original: File[] | null) => {
            if (original?.length) {
                const docs = original.map((file) => {
                    return new File([file], file.name, { type: file.type });
                });
                setFiles(docs);
            }
        },
        [setFiles]
    );

    const handleFileClick = useCallback(
        (files: FileContent[], original: File[] | null) => {
            if (original?.length) {
                const docs = original.map((file) => {
                    return new File([file], file.name, { type: file.type });
                });
                setFiles(docs);
            }
        },
        [setFiles]
    );

    return (
        <>
            <Box className="newCommentForm__attachmentsContainer">
                <DragAndDropFiles onDrop={handleFileDrop} onClick={handleFileClick} />
                <Box className="newCommentForm__attachmentsContainer__chipsContainer">
                    {files?.map((attachment, index) => {
                        return (
                            <Chip
                                label={attachment.name}
                                onDelete={() => removeAttachment(index)}
                                key={`${attachment.name}-${index}`}
                                className="newCommentForm__attachmentsContainer__chipsContainer__chip"
                            />
                        );
                    })}
                    {errorMsg ? (
                        <Box sx={{ color: MirageTheme.palette.error.main, width: "100%", display: "flex", gap: "0.5rem" }}>
                            <FontAwesomeIcon icon={MirageTheme.icons.dangerIcon} />
                            <Typography fontSize="13px">{errorMsg}</Typography>
                        </Box>
                    ) : null}
                </Box>
            </Box>
        </>
    );
});

export default NewCommentAttachments;
